export enum InputEnum {
  checkbox = 'checkbox',
  radio = 'radio'
}

export const InputValues = Object.values(InputEnum)
export type InputArray = typeof InputValues
export type TypeInput = InputArray[number]
